module.exports = __webpack_public_path__ + "assets/img/shouye_youlexiangmu-xuanzhong.d311f300.svg";